import type { UserSubscription } from '@/types/api';

export const hasCurrentDataAccess = (subscription?: UserSubscription | null): boolean =>
  Boolean(subscription?.features?.has_current_data);

export const hasPremiumAccess = (subscription?: UserSubscription | null): boolean =>
  hasCurrentDataAccess(subscription);

export const isFreeAccessUser = (subscription?: UserSubscription | null): boolean =>
  !hasPremiumAccess(subscription);

export const hasActivePaidSubscription = (subscription?: UserSubscription | null): boolean =>
  Boolean(
    subscription?.stripe_subscription_id &&
    subscription.status === 'active' &&
    !subscription.cancel_at_period_end &&
    !subscription.is_grandfathered
  );
